import React, { useEffect, useState } from "react";
import "./Review.css";
import userApi from "../../HTTP/user";
import ArticleBlocks from "../Review/ArticleBlocks";
import { addArticlesToReview } from "../../HTTP/articles";

const user = JSON.parse(localStorage.getItem("user"));

const formatCreationDate = (dateValue) => {
  if (!dateValue) return "-";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

const AddToReview = () => {
  const params = new URLSearchParams(window.location.search);
  const articles = JSON.parse(decodeURIComponent(params.get("data")));

  articles.forEach((item) => {
    delete item.publication_date;
    delete item.id;
  });

  const [reviews, setReviews] = useState([]);
  const [selectedReviewId, setSelectedReviewId] = useState("");

  useEffect(() => {
    const fetchReviews = async () => {
      const reviewsData = await userApi.getUserReviews(user.id);
      setReviews(reviewsData?.reviews || []);
    };

    fetchReviews();
  }, []);

  const selectedReview = reviews.find(
    (review) => String(review.id) === String(selectedReviewId)
  );

  const addToReviewValidate = () => {
    if (!selectedReviewId) {
      return;
    }

    addArticlesToReview(articles, selectedReviewId).then((res) => {
      if (res === true) {
        alert("Articles added !");
        window.location.href = `/editreviews/${selectedReviewId}`;
      } else {
        alert("Erreur");
      }
    });
  };

  return (
    <div className="m-4">
      <h1>Ajouter à une revue de presse</h1>
      <ArticleBlocks articles={articles} />

      <h2 className="text-lg font-bold mt-6 mb-3">Choix de la revue de presse</h2>

      {reviews.length === 0 && (
        <p className="text-gray-600 mb-4">Aucune revue de presse disponible.</p>
      )}

      {reviews.length > 0 && (
        <div className="space-y-3 max-h-[40vh] overflow-y-auto mb-6">
          {reviews.map((review) => {
            const isSelected = String(review.id) === String(selectedReviewId);
            return (
              <button
                key={review.id}
                type="button"
                onClick={() => setSelectedReviewId(String(review.id))}
                className={`w-full text-left rounded-lg border p-4 transition ${
                  isSelected
                    ? "border-yellow-500 bg-yellow-50"
                    : "border-gray-200 bg-white hover:border-yellow-300"
                }`}
              >
                <p className="font-semibold">{review.theme}</p>
                <p className="text-sm text-gray-700 whitespace-pre-line mt-1">
                  {review.presentation || "-"}
                </p>
                <p className="text-xs text-gray-500 mt-2">
                  Créée le {formatCreationDate(review.creation_date)}
                </p>
              </button>
            );
          })}
        </div>
      )}

      <div className="mt-6">
        {selectedReview && (
          <p className="text-sm text-gray-700 mb-3">
            Revue sélectionnée: <strong>{selectedReview.theme}</strong>
          </p>
        )}
        <button
          type="button"
          className={`font-bold py-2 px-4 rounded ${
            selectedReviewId
              ? "bg-yellow-400 text-black"
              : "bg-gray-300 text-gray-600 cursor-not-allowed"
          }`}
          onClick={addToReviewValidate}
          disabled={!selectedReviewId}
        >
          Ajouter
        </button>
      </div>
    </div>
  );
};

export default AddToReview;
